import { render, staticRenderFns } from "./QuickAccess.vue?vue&type=template&id=28f2d68e&scoped=true"
import script from "./QuickAccess.vue?vue&type=script&lang=js"
export * from "./QuickAccess.vue?vue&type=script&lang=js"
import style0 from "./QuickAccess.vue?vue&type=style&index=0&id=28f2d68e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28f2d68e",
  null
  
)

export default component.exports